import React from 'react';
import './FAQ.scss';

function FAQ() {
  const faqs = [
    {
      question: "How do I perform member operations on the Service Portal?",
      answer: "Under the “Members” menu item, select the member operation of interest (Add Member, Remove Member, Change Salary, or Add Dependent)."
    },
    {
      question: "How do I access my scheme reports?",
      answer: "Under the scheme details tab, select the report of interest from the drop-down menu items."
    },
    {
      question: "What do I do if the portal is inaccessible, slow, or not functioning as expected?",
      answer: ""
    },
    {
      question: "How do I contact Britam?",
      answer: "grouplifeservice@britam.com, partnershiplifeservice@britam.com."
    },
    {
      question: "What do I expect after any member operation?",
      answer: "A debit note, or a credit note under the “Scheme Details” menu item."
    },
    {
      question: "What happens if a member sum assured is above the Free Cover Limit?",
      answer: "The member should be sent for medical examination, after which medical underwriting will be done and cover terms issued, otherwise cover will be restricted to the FCL."
    },
    {
      question: "What is the cover age limits for my scheme?",
      answer: "18 – 80 For main members with the facultative age from 70 years. Age based rates are applicable from age 65."
    },
    {
      question: "What is facultative age?",
      answer: "The age beyond which members are accepted for cover on a case-by-case scrutiny, with medical underwriting."
    }
  ];

  return (
    <div className="faq-container">
      <h1 className="faq-title">Frequently Asked Questions</h1>
      <div className="faqs">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <h2 className="faq-question">{faq.question}</h2>
            <p className="faq-answer">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQ;